import * as actionTypes from './actionTypes';
import {getData} from "../../shared/networkUtil";

export const getOrderFormRequest = () => ({
    type: actionTypes.GET_ORDER_FORM_REQUEST
});

export const getOrderFormSuccess = orderForm => ({
    type: actionTypes.GET_ORDER_FORM_SUCCESS,
    data: orderForm
});

export const getOrderFormError = error => ({
    type: actionTypes.GET_ORDER_FORM_ERROR,
    error: error
});


export const getOrderForm = (id) => dispatch => {
    dispatch(getOrderFormRequest());
    getData(
        "/order-forms/" + id,
        response => {
            dispatch(getOrderFormSuccess(response.data));
        },
        error => {
            console.log(error);
            dispatch(getOrderFormError(error));
        }
    );
};
